import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';
import App from './App';
import './index.css';

/* =========================
   ResizeObserver noise killer
   ========================= */

const isResizeObserverError = (input) => {
  if (!input) return false;

  let msg = '';

  if (typeof input === 'string') {
    msg = input;
  } else if (input instanceof Error && typeof input.message === 'string') {
    msg = input.message;
  } else if (typeof input.message === 'string') {
    msg = input.message;
  }

  return (
    msg.includes('ResizeObserver loop completed with undelivered notifications.') ||
    msg.includes('ResizeObserver loop limit exceeded') ||
    msg.includes('ResizeObserver loop')
  );
};

// Patch console in development only
if (process.env.NODE_ENV === 'development') {
  const origError = console.error;
  const origWarn = console.warn;

  console.error = (...args) => {
    if (args.some(isResizeObserverError)) {
      // swallow ResizeObserver garbage
      return;
    }
    origError(...args);
  };

  console.warn = (...args) => {
    if (args.some(isResizeObserverError)) {
      // swallow ResizeObserver garbage
      return;
    }
    origWarn(...args);
  };
}

// Catch global errors (some browsers throw ResizeObserver as a window error)
window.addEventListener(
  'error',
  (event) => {
    if (isResizeObserverError(event?.message || event?.error)) {
      event.stopImmediatePropagation();
      // optional: event.preventDefault();
    }
  },
  true // capture phase, so we beat React's own handlers
);

// Catch promise rejections
window.addEventListener(
  'unhandledrejection',
  (event) => {
    if (isResizeObserverError(event?.reason)) {
      event.preventDefault();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    }
  },
  true
);

/* =========================
   Amplify + React bootstrap
   ========================= */

Amplify.configure(awsExports);

const rootEl = document.getElementById('root');
const root = ReactDOM.createRoot(rootEl);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
